import React, { useReducer } from 'react';
import AgbaReducer from './agbaReducer';
import AgbaContext from './agbaContext';
import { getBlogPosts } from '../../contentful';

import {
  OPEN_SIDEBAR,
  CLOSE_SIDEBAR,
  GET_SUCCESS,
  SET_LOADING,
} from '../types';

const AgbaState = (props) => {
  const initialState = {
    sideBar: false,
    projects: [],
    error: null,
    loading: true,
  };

  const [state, dispatch] = useReducer(AgbaReducer, initialState);

  const openNav = () => {
    dispatch({ type: OPEN_SIDEBAR });
  };
  const closeNav = () => {
    dispatch({ type: CLOSE_SIDEBAR });
  };
  const setLoading = () => {
    dispatch({ type: SET_LOADING });
  };

  const getProjects = async () => {
    try {
      setLoading();
      const response = await getBlogPosts();
      dispatch({ type: GET_SUCCESS, payload: response });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <AgbaContext.Provider
      value={{
        sideBar: state.sideBar,
        projects: state.projects,
        loading: state.loading,
        openNav,
        closeNav,
        getProjects,
      }}
    >
      {props.children}
    </AgbaContext.Provider>
  );
};

export default AgbaState;
